import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/aseguradoras/';

/**
 * GET Aseguradoras
 * @returns {Promise<Array<object>>}
 */
export const getAseguradoras = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Aseguradora
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getAseguradora = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Aseguradora
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAseguradora = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Aseguradora
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAseguradora = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Aseguradora
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteAseguradora = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
